import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsComponent } from './settings.component';
import { MaterialModule } from 'src/app/material.module';
import { StatusModule } from 'src/app/platform/nomenclatoare/cerere-status/status.module';
import { CererePriorityModule } from 'src/app/platform/nomenclatoare/cerere-priority/cerere-priority.module';
import { RequestTypesModule } from 'src/app/platform/nomenclatoare/cerere-type/cerere-type.module';
import { ZileLibereModule } from 'src/app/platform/nomenclatoare/zile libere/zile-libere.module';
import { LocatiiModule } from 'src/app/platform/nomenclatoare/locatii/locatii.module';
import { ModuleModule } from 'src/app/platform/nomenclatoare/module/module.module';
import { ModuleTipuriProgramModule } from 'src/app/platform/nomenclatoare/module-tipuri-program/module-tipuri-program.module';
import { ModuleTipuriProgramActiveModule } from 'src/app/platform/nomenclatoare/module-tipuri-program-active/module-tipuri-program-active.module';
import { ModuleLocatiiActiveModule } from 'src/app/platform/nomenclatoare/module-locatii-active/module-locatii-active.module';
import { OperatoriModule } from 'src/app/platform/nomenclatoare/operatori/operatori.module';
import { DocumentTypeModule } from 'src/app/platform/nomenclatoare/document-type/document-type.module';
import { DocumentCategoryModule } from 'src/app/platform/nomenclatoare/document-category/document-category.module';

@NgModule({
    declarations: [SettingsComponent],
    imports: [
        CommonModule,
        MaterialModule,
        StatusModule,
        CererePriorityModule,
        RequestTypesModule,
        ZileLibereModule,
        LocatiiModule,
        ModuleModule,
        ModuleTipuriProgramModule,
        ModuleTipuriProgramActiveModule,
        ModuleLocatiiActiveModule,
        OperatoriModule,
        DocumentTypeModule,
        DocumentCategoryModule
    ],
    exports: [SettingsComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SettingsModule { }
